// extracted by mini-css-extract-plugin
module.exports = {"CheckboxField":"styles_CheckboxField__kNfiG","CheckboxFieldTick":"styles_CheckboxFieldTick__Zw1oZ","CheckboxFieldTick__checked":"styles_CheckboxFieldTick__checked__5tnme"};